import LoginIcon from '@mui/icons-material/Login';
import { Alert, Button, Stack, Typography } from '@mui/material';
import { useParams } from 'react-router';
import { useUitnodiging } from '../api/auth.ts';
import { Laadstatus } from '../componenten/Laadstatus.tsx';
import { datumTijd } from '../helpers/formatteer.ts';
import { Aanmeldkader } from './AanmeldPagina.tsx';

/**
 * De pagina achter een uitnodigingslink: controleert de uitnodiging en toont per aanmeldmethode een knop.
 * Wie zich via zo'n knop aanmeldt, wordt aan het uitgenodigde account gekoppeld.
 * @returns De pagina.
 */
export function UitnodigingPagina() {
  const { token = '' } = useParams();
  const uitnodiging = useUitnodiging(token);
  const terugNaar = new URL('/', window.location.origin).href;

  return (
    <Aanmeldkader>
      <Laadstatus query={uitnodiging}>
        {(gegevens) => (
          <Stack spacing={2}>
            <Typography>
              Welkom, <strong>{gegevens.naam}</strong>. Kies hoe je je wilt aanmelden. De uitnodiging is geldig tot{' '}
              {datumTijd(gegevens.verlooptOp)}.
            </Typography>
            {gegevens.aanmeldUrls.length === 0 ? (
              <Alert severity="warning">Er is nog geen aanmeldmethode ingeschakeld op de server.</Alert>
            ) : (
              gegevens.aanmeldUrls.map((adres) => {
                const url = new URL(adres.url, window.location.origin);
                url.searchParams.set('terugNaar', terugNaar);
                return (
                  <Button
                    key={adres.provider}
                    href={url.href}
                    variant="contained"
                    size="large"
                    startIcon={<LoginIcon />}
                    fullWidth
                  >
                    Aanmelden met {adres.naam}
                  </Button>
                );
              })
            )}
          </Stack>
        )}
      </Laadstatus>
    </Aanmeldkader>
  );
}
